import { useEffect, FocusEvent, useCallback } from 'react';
import { Field } from 'react-final-form';
import { connect, useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { IImportTemplate } from 'APIPackage/ImportExportModule/interfaces/IImportTemplate';
import { TextInput } from 'UIPackage/MainModule/components/TextInput';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { UploadFileTypesEnum } from 'CorePackage/MainModule/enums/UploadFileTypesEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { getImportTemplate } from '../selectors/importSelectors';
import {
  importGetTemplate,
  importSetKnmTypeId,
  importSetSubjectTypeErvkId,
  importSetSubjectTypeId,
  importSetSupervisionTypeErvkId,
  importSetTemplate,
} from '../actions/importActions';

interface IUploadPlanIdFieldProps {
  className?: string;
  getFormFileTypeId: () => keyof typeof UploadFileTypesEnum | undefined;
  onImportChange?: (importTemplate: IImportTemplate | undefined) => void;
}

interface IUploadPlanIdFieldStoreProps {
  importTemplate: IImportTemplate | undefined;
}

const UploadPlanIdFieldWithoutStore = ({
  className,
  importTemplate,
  getFormFileTypeId,
  onImportChange,
}: IUploadPlanIdFieldProps & IUploadPlanIdFieldStoreProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  useEffect(() => {
    if (onImportChange) {
      onImportChange(importTemplate);
    }
  }, [importTemplate, onImportChange]);

  const handleTextInputBlur = useCallback(
    (e: FocusEvent<HTMLInputElement>) => {
      const planId = e.target.value;

      if (planId !== String(importTemplate?.planId)) {
        dispatch(importSetTemplate());
        dispatch(importSetKnmTypeId(undefined));
        dispatch(importSetSubjectTypeId(undefined));
        dispatch(importSetSubjectTypeErvkId(undefined));
        dispatch(importSetSupervisionTypeErvkId(undefined));
        const fileTypeId = getFormFileTypeId();

        if (fileTypeId && UploadFileTypesEnum[fileTypeId] === UploadFileTypesEnum.PLAN_CORRECTION && Number(planId)) {
          dispatch(importGetTemplate(Number(planId)));
        }
      }
    },
    [dispatch, getFormFileTypeId, importTemplate?.planId],
  );

  return (
    <Field name="planId">
      {props => {
        return (
          <TextInput className={className} id={props.input.name} name={props.input.name} onBlur={handleTextInputBlur} />
        );
      }}
    </Field>
  );
};

const mapStateToProps = (state: IRootState): IUploadPlanIdFieldStoreProps => ({
  importTemplate: getImportTemplate(state),
});

export const UploadPlanIdField = connect(mapStateToProps)(UploadPlanIdFieldWithoutStore);
